import locales from './wsc-locales'
import _get from 'lodash/get'

/**
 * @param model
 * @param prop
 * @param locale
 * @returns {null}
 */
export function translatable (model, prop, locale = undefined) {
  return _get(model, ['translatable', getLocale(locale), prop])
}

/**
 * @param model
 * @param prop
 * @param locale
 * @returns {null}
 */
export function translatableOrDefault (model, prop, locale = undefined) {
  return translatable(model, prop, locale) || _get(model, ['translatable', getDefaultLocale(), prop])
}

/**
 * @param locale
 * @returns string
 */
function getLocale (locale = undefined) {
  return locale || locales.usedLocale
}

/**
 * @param locale
 * @returns string
 */
function getDefaultLocale () {
  return locales.defaultLocale
}



// WEBPACK FOOTER //
// ./client/plugins/wsc-translatable.js